export const FETCH_ACCOUNT_SETTING_INIT = 'FETCH_ACCOUNT_SETTING_INIT';
export const FETCH_ACCOUNT_SETTING_SUCCESS = 'FETCH_ACCOUNT_SETTING_SUCCESS';
export const FETCH_ACCOUNT_SETTING_FAILURE = 'FETCH_ACCOUNT_SETTING_FAILURE';

export const SAVE_ACCOUNT_SETTING_INIT = 'SAVE_ACCOUNT_SETTING_INIT';
export const SAVE_ACCOUNT_SETTING_SUCCESS = 'SAVE_ACCOUNT_SETTING_SUCCESS';
export const SAVE_ACCOUNT_SETTING_FAILURE = 'SAVE_ACCOUNT_SETTING_FAILURE';


// WEBPACK FOOTER //
// ./source/client/actions/account_setting/types.js